import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Dashboard from './pages/Dashboard';
import SolicitarTurno from './pages/SolicitarTurno';
import AdminTurnos from './pages/AdminTurnos';
import CalendarioTurnos from './pages/CalendarioTurnos';
import PrivateRoute from './components/PrivateRoute';
import AdminTurnosAprobados from './pages/AdminTurnosAprobados';
import SolicitarTurnoProveedor from './pages/SolicitarTurnoProveedor';
import CambiarClave from './pages/CambiarClave';
import CrearTurnoTransportista from './pages/CrearTurnoTransportista';
import CrearTurnoProveedor from './pages/CrearTurnoProveedor';
import PorteriaTurnos from './pages/PorteriaTurnos';
import AdminUsuarios from './pages/AdminUsuarios';
import OlvideClave from './pages/OlvideClave';
import RestablecerClave from './pages/RestablecerClave';

const AppRoutes = () => (
  <Router>
    <Routes>
      {/*Público*/}
      <Route path="/" element={<Login />} />
      <Route path="/registro" element={<Registro />} />
      <Route path="/olvide-clave" element={<OlvideClave />} />
      <Route path="/restablecer-clave" element={<RestablecerClave />} />

      {/*Cambio de clave*/}
      <Route
        path="/cambiar-clave"
        element={
          <PrivateRoute>
            <CambiarClave />
          </PrivateRoute>
        }
      />

      {/*Dashboard*/}
      <Route
        path="/dashboard"
        element={
          <PrivateRoute allowedRoles={['transportista', 'proveedor']}>
            <Dashboard />
          </PrivateRoute>
        }
      />

      {/*Turnos transportista*/}
      <Route
        path="/solicitar-turno"
        element={
          <PrivateRoute allowedRoles={['transportista']}>
            <SolicitarTurno />
          </PrivateRoute>
        }
      />

      {/*Turnos proveedor*/}
      <Route
        path="/solicitar-turno-proveedor"
        element={
          <PrivateRoute allowedRoles={['proveedor']}>
            <SolicitarTurnoProveedor />
          </PrivateRoute>
        }
      />

      {/*Administración*/}
      <Route
        path="/admin-turnos"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <AdminTurnos />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/turnos-aprobados"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <AdminTurnosAprobados />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/calendario"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <CalendarioTurnos />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/crear-turno-transportista"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <CrearTurnoTransportista />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/crear-turno-proveedor"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <CrearTurnoProveedor />
          </PrivateRoute>
        }
      />

      {/*Portería*/}
      <Route
        path="/admin/usuarios"
        element={
          <PrivateRoute allowedRoles={['admin']}>
            <AdminUsuarios />
          </PrivateRoute>
        }
      />
      <Route
        path="/porteria-turnos"
        element={
          <PrivateRoute allowedRoles={['porteria', 'admin']}>
            <PorteriaTurnos />
          </PrivateRoute>
        }
      />
    </Routes>
  </Router>
);

export default AppRoutes;

